var map = {
	"./barbu.json": [
		9137,
		9137
	],
	"./batak.json": [
		406,
		406
	],
	"./bezik.json": [
		2224,
		2224
	],
	"./blackjack.json": [
		1933,
		1933
	],
	"./blof.json": [
		5856,
		5856
	],
	"./blum.json": [
		3703,
		3703
	],
	"./dostkazigi.json": [
		7664,
		7664
	],
	"./ellibir.json": [
		3162,
		3162
	],
	"./fantan.json": [
		2927,
		2927
	],
	"./hosgin.json": [
		2395,
		2395
	],
	"./kanasta.json": [
		6636,
		6636
	],
	"./king.json": [
		4696,
		4696
	],
	"./macakizi.json": [
		8512,
		8512
	],
	"./papazkacti.json": [
		2655,
		2655
	],
	"./papazkimde.json": [
		6377,
		6377
	],
	"./pisti.json": [
		7414,
		7414
	],
	"./pisyedili.json": [
		5308,
		5308
	],
	"./solitaire.json": [
		2841,
		2841
	],
	"./ucbessekiz.json": [
		2551,
		2551
	],
	"./yanik.json": [
		8317,
		8317
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7926;
module.exports = webpackAsyncContext;